import { Skeleton } from "@/components/ui/skeleton";

export const PostHashLoading = () => {
  return (
    <div className="p-4">
      <Skeleton className="h-10 w-full" />

      <div className="my-4">
        <div className="flex flex-wrap">
          <div>
            <Skeleton className="size-14 rounded-full" />
          </div>

          <div className="flex grow flex-wrap">
            <div className="w-1/2 px-4 py-2">
              <Skeleton className="mb-2 h-3 w-1/3" />
              <Skeleton className="h-3 w-1/3" />
            </div>

            <div className="flex w-1/2 gap-x-4">
              <Skeleton className="h-8 w-1/3" />
              <Skeleton className="h-8 w-1/3" />
              <Skeleton className="h-8 w-1/3" />
            </div>
          </div>

          <Skeleton className="my-4 h-[200px] w-full"></Skeleton>
        </div>
      </div>
    </div>
  );
};
